import React from 'react'
import { connect } from 'react-redux'
import EnablementInsightTabTable from './EnablementInsightTabTable'
import EnablementSupplierDetailsPopup from './EnablementSupplierDetailsPopup'
import ExpandableTable from './ExpandableTable'
import { path, dropdownColourStyles } from 'Constants'
import { ControlTextE, ScreenE, SelectE } from 'UI/CustomComponents/Controls';
import { sortAndFilterEnabelemetWaves } from 'utils/Utils'

// Settings
import { changeModalBorderStyle, drilldownModalBorderContentStyle, changeModalBorderRectStyle } from 'Constants'
import Modal from 'reboron/OutlineModal'

import {
    enablementInsightSuccess,
    enablementInsightFailure,
    enablementInsightLoading,
    resetError,
    getEnablementDetails,
    getEnablementStrategyDetails,
    getEnablementStrategyDetailsEnablementType,
    getEnablementFiltersDetails,
    currentActiveRequest,
    updateEnablementStrategyCurrentFocus
} from 'actions/spendActions'

class EnablementDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enablementWaveData: [],
            enablementWaveTotal: [],
            enablementWaveJson: [],
            enablementTypesJson: [],
            enablementTypes: [],
            enablementTypeJson: null,
            grandTotal: [],
            isLoading: true,
            responseMsg: '',
            inputParam: {
                Direct_Connect_Wave: this.props.spendDetails.currentActiveRequest.DIRECT_CONNECT_WAVE,
                DMC_ID: this.props.spendDetails !== undefined && this.props.spendDetails.currentActiveRequest !== undefined ? this.props.spendDetails.currentActiveRequest.DMC_ID : 0
                , VS_ID: this.props.spendDetails !== undefined && this.props.spendDetails.currentActiveRequest !== undefined ? this.props.spendDetails.currentActiveRequest.VS_ID : 0,
                User_Email: this.props.spendDetails.currentActiveRequest !== undefined &&
                    this.props.spendDetails.currentActiveRequest.SAPRequester === this.props.user.user.Email ? this.props.user.user.Email : this.props.spendDetails.currentActiveRequest.SAPRequester,
                dedupStats: 'Unique',
                enabledCustomer: 'all',
                transactingCustomer: 'all',
                buyerRegion: 'all',
                businessUnit: 'all',
                erpSystem: 'all',
                l4IndustryName: 'all',
                erpCode: 'all',
                erpDesc: 'all',
                sicCode: 'all',
                sicDesc: 'all',

                goods: 'all',
                invoiceCountry: 'all',
                legalInvoice: 'all',
                aribaNwEligible: 'all',
                column1Name: 'SAP_ARIBA_BUY_ENABLE_MTHD_RECMD',
                column1Value: '',
                tableName: '',
                valuesUpdated: false,
                metricsType: 'Invoice Spend',
                directSpend: 'all'
            },
            isL4Expand: true,
            isCountryExpand: true,
            isOnboardWrkExpand: true,
            isRECMDExpand: true,
            tableNameOption: [
                { value: "l4Industry", label: "Enablement Strategy by Onboarding Workstream with L4 Industry Name" },
                { value: "isoCountry", label: "Enablement Strategy by Onboarding Workstream with ISO Country Code" },
                { value: "workstreamDetails", label: "Enablement Strategy by Onboarding Workstream with Details" },
                { value: "workstreamRecommendation", label: "Enablement Strategy by Onboarding Workstream with Enablement Recommendation" },
            ],
            tableNameOptionForEnablemenType: [
                {
                    value: "enablementTypeL4",
                    label: "Enablement Strategy by Enablement Type by Onboarding Workstream with L4 Industry Name"
                },
                {
                    value: "enablementTypeISO",
                    label: "Enablement Strategy by Enablement Type by Onboarding Workstream with ISO Country Code"
                },
                {
                    value: "enablementTypeDetails",
                    label: "Enablement Strategy by Enablement Type by Onboarding Workstream with Details"
                },
                {
                    value: "enablementTypeRecommendation",
                    label: "Enablement Strategy by Enablement Type by Onboarding Workstream with Enablement Recommendation"
                }
            ],
            selectedTableView:
    this.props.spendDetails !== undefined &&
    this.props.spendDetails.currentActiveRequest !== undefined
        ? (
            this.props.spendDetails.currentActiveRequest.ENABLEMENT_STRATEGY_FOCUS === "enablementTypeL4"
                ? "enablementTypeL4"
                : this.props.spendDetails.currentActiveRequest.ENABLEMENT_STRATEGY_FOCUS
        )
        : "l4Industry",
            activeRequest: this.props.spendDetails.currentActiveRequest
        }
        this.showEnablementSupplierDetailsModal = this.showEnablementSupplierDetailsModal.bind(this)
        this.setVisibility = this.setVisibility.bind(this)
        this.outsidePopupClick = this.outsidePopupClick.bind(this)
        this.onSave = this.onSave.bind(this)
        this.reloadEnablementWave = this.reloadEnablementWave.bind(this)
        this.renameKeyDeep = this.renameKeyDeep.bind(this)
    }

    componentDidMount() {
        ////this.convertResponseToJson()
        this.GetEnablementDetails(this.state.inputParam)
    }

    reloadEnablementWave() {
        this.GetEnablementDetails(this.state.inputParam)
    }

    showEnablementSupplierDetailsModal(
        tableName,
        columnName,
        columnValue,
        columnValue2,
        columnValue3,
        columnValue4
      ) {
        // console.log("🔍 Modal callback:", {
        //   tableName,
        //   columnName,
        //   columnValue,
        //   columnValue2,
        //   columnValue3,
        //   columnValue4
        // });
      
        var inputParameter = this.state.inputParam;
      
        inputParameter.tableName = tableName;
      
        // ---------------------------------------------------------
        // COLUMN 1
        // Always ENABLEMENT_WAVE for this popup
        // ---------------------------------------------------------
        inputParameter.column1Name = "ENABLEMENT_WAVE";
        inputParameter.column1Value =
          columnValue !== undefined ? columnValue : null;
      
        const enablementTypeViews = [
          "enablementTypeL4",
          "enablementTypeISO",
          "enablementTypeDetails",
          "enablementTypeRecommendation"
        ];
      
        const isEnablementTypeView =
          enablementTypeViews.includes(this.state.selectedTableView);
      
        // ---------------------------------------------------------
        // ENABLEMENT TYPE VIEWS
        //
        // Column 1 = ENABLEMENT_WAVE
        // Column 2 = enablementTypeSecCol
        // Column 3 = enablementWaveSecCol
        // Column 4 = dynamic
        // ---------------------------------------------------------
        if (isEnablementTypeView) {
      
          // Column 2
          inputParameter.column2Name =
            this.props.content.enablementTypeSecCol;
      
          inputParameter.column2Value =
            columnValue2 !== undefined ? columnValue2 : null;
      
          // Column 3
          inputParameter.column3Name =
            this.props.content.enablementWaveSecCol;
      
          inputParameter.column3Value =
            columnValue3 !== undefined ? columnValue3 : null;
      
          // Column 4
          inputParameter.column4Value =
            columnValue4 !== undefined ? columnValue4 : null;
      
          switch (this.state.selectedTableView) {
      
            case "enablementTypeL4":
              inputParameter.column4Name =
                this.props.content.enablementWaveL4IndustryCol;
              break;
      
            case "enablementTypeISO":
              inputParameter.column4Name =
                this.props.content.enablementWaveISOCountryCol;
              break;
      
            case "enablementTypeDetails":
              inputParameter.column4Name =
                this.props.content.enablementWaveWorkStreamDetailCol;
              break;
      
            case "enablementTypeRecommendation":
              inputParameter.column4Name =
                this.props.content.enablementWaveThirdCol;
              break;
      
            default:
              inputParameter.column4Name = null;
              inputParameter.column4Value = null;
              break;
          }
      
        } else {
      
          // -------------------------------------------------------
          // NORMAL VIEWS
          //
          // Column 1 = ENABLEMENT_WAVE
          // Column 2 = enablementWaveSecCol
          // Column 3 = dynamic
          // -------------------------------------------------------
      
          inputParameter.column2Name =
            this.props.content.enablementWaveSecCol;
      
          inputParameter.column2Value =
            columnValue2 !== undefined ? columnValue2 : null;
      
          inputParameter.column3Value =
            columnValue3 !== undefined ? columnValue3 : null;
      
          switch (tableName) {
      
            case this.props.content.enablementWaveDetails
              .enablementStrategyByL4Industry:
      
              inputParameter.column3Name =
                this.props.content.enablementWaveL4IndustryCol;
              break;
      
            case this.props.content.enablementWaveDetails
              .enablementStrategyByISOCountry:
      
              inputParameter.column3Name =
                this.props.content.enablementWaveISOCountryCol;
              break;
      
            case this.props.content.enablementWaveDetails
              .enablementStrategyByOnboardingWorkstream:
      
              inputParameter.column3Name =
                this.props.content.enablementWaveWorkStreamDetailCol;
              break;
      
            case this.props.content.enablementWaveDetails
              .enablementStrategyByRecommendation:
      
              inputParameter.column3Name =
                this.props.content.enablementWaveThirdCol;
              break;
      
            default:
              inputParameter.column3Name = null;
              inputParameter.column3Value = null;
              break;
          }
      
          // Normal views do not have Column 4
          inputParameter.column4Name = null;
          inputParameter.column4Value = null;
        }
      
        // console.log("📌 Supplier Details Request:", {
        //   tableName: inputParameter.tableName,
      
        //   column1Name: inputParameter.column1Name,
        //   column1Value: inputParameter.column1Value,
      
        //   column2Name: inputParameter.column2Name,
        //   column2Value: inputParameter.column2Value,
      
        //   column3Name: inputParameter.column3Name,
        //   column3Value: inputParameter.column3Value,
      
        //   column4Name: inputParameter.column4Name,
        //   column4Value: inputParameter.column4Value
        // });
      
        this.setState({
          openPopup: true,
          inputParam: inputParameter
        });
      }
    onSave(value) {
        this.setState({ valuesUpdated: value })
    }

    setVisibility(isVisible) {
        this.handlePoupClose()
    }

    outsidePopupClick() {
        this.handlePoupClose()
    }

    handlePoupClose() {
        this.setState({ open: false, openPopup: false }, () => {
            if (this.state.valuesUpdated) {
                this.setState({ valuesUpdated: false }, this.GetEnablementDetails(this.state.inputParam))
            }
        })
    }

    showAdvanceFilter() {
        var advanceFilterDiv = document.getElementById('advanceFilter').style;
        if (advanceFilterDiv.display === "none") {
            advanceFilterDiv.display = "block";
        } else {
            advanceFilterDiv.display = "none";
        }
    }

    renameKeyDeep(obj, oldKey, newKey) {
        if (Array.isArray(obj)) {
            return obj.map(item => this.renameKeyDeep(item, oldKey, newKey));
        } else if (obj !== null && typeof obj === 'object') {
            const newObj = {};
            for (let key in obj) {
                const value = obj[key];
                // Rename if key matches
                if (key === oldKey) {
                    newObj[newKey] = this.renameKeyDeep(value, oldKey, newKey);
                } else {
                    newObj[key] = this.renameKeyDeep(value, oldKey, newKey);
                }
            }
            return newObj;
        }
        return obj; // primitive values
    }

    getEnablementTypeViewConfig() {

        switch (this.state.selectedTableView) {
    
            case "enablementTypeL4":
                return {
                    dataKey: "L4_INDUSTRY_GICS_ID",
                    displayField: "FIELD_DESC"
                };
    
            case "enablementTypeISO":
                return {
                    dataKey: "ISO_COUNTRY_CODE",
                    displayField: "ISO_COUNTRY_CODE"
                };
    
            case "enablementTypeDetails":
                return {
                    dataKey: "ONBOARDING_WORKSTREAM_DETAILS",
                    displayField: "ONBOARDING_WORKSTREAM_DETAILS"
                };
    
            case "enablementTypeRecommendation":
                return {
                    dataKey: "SAP_ARIBA_BUY_ENABLE_MTHD_RECMD",
                    displayField: "SAP_ARIBA_BUY_ENABLE_MTHD_RECMD"
                };
    
            default:
                return {
                    dataKey: "L4_INDUSTRY_GICS_ID",
                    displayField: "FIELD_DESC"
                };
        }
    }

    buildEnablementTypeView(selectedView) {

        let l4Data = [];
        let displayField = "FIELD_DESC";
    
        switch (selectedView) {
    
            case "enablementTypeL4":
                l4Data = this.state.enablementTypeL4Data || [];
                displayField = "FIELD_DESC";
                break;
    
            case "enablementTypeISO":
                l4Data = this.state.enablementTypeISOData || [];
                displayField = "ISO_COUNTRY_CODE";
                break;
    
            case "enablementTypeDetails":
                l4Data = this.state.enablementTypeDetailsData || [];
                displayField = "ONBOARDING_WORKSTREAM_DETAILS";
                break;
    
            case "enablementTypeRecommendation":
                l4Data = this.state.enablementTypeRecommendationData || [];
                displayField = "SAP_ARIBA_BUY_ENABLE_MTHD_RECMD";
                break;
    
            default:
                l4Data = this.state.enablementTypeL4Data || [];
                displayField = "FIELD_DESC";
                break;
        }
    
        const enablementTypeJson =
            this.convertEnablementTypeResponse(
                this.state.enablementTypeRows || [],
                this.state.enablementTypeGrandTotal,
                l4Data,
                displayField
            );
    
        this.setState({
            enablementTypeJson: enablementTypeJson,
            enablementWaveTotal: this.state.enablementTypeGrandTotal,
            isLoading: false
        });
    }

    GetEnablementDetails(inputParam) {

        this.state.inputParam.Direct_Connect_Wave =
            this.props.spendDetails.currentActiveRequest.DIRECT_CONNECT_WAVE;
    
        this.state.inputParam.Enablement_Strategy_Focus =
            this.state.selectedTableView;
    
        /*
         * ============================================================
         * ENABLEMENT TYPE VIEWS
         * ============================================================
         *
         * One API call returns all required data:
         *
         * 1. ENABLEMENT_TYPE
         * 2. L4_INDUSTRY_GICS_ID
         * 3. ISO_COUNTRY_CODE
         * 4. ONBOARDING_WORKSTREAM_DETAILS
         * 5. SAP_ARIBA_BUY_ENABLE_MTHD_RECMD
         * 6. GrandTotal
         *
         * Do NOT call the API separately for each dropdown value.
         * ============================================================
         */
    
        const enablementTypeViews = [
            "enablementTypeL4",
            "enablementTypeISO",
            "enablementTypeDetails",
            "enablementTypeRecommendation"
        ];
    
        if (enablementTypeViews.includes(this.state.selectedTableView)) {
    
            this.props.getEnablementStrategyDetailsEnablementType(inputParam)
                .then((response) => {
    
                    if (
                        response !== undefined &&
                        response.status === 200 &&
                        response.data.Result !== undefined
                    ) {
    
                        let enablementTypeRows = [];
                        let enablementTypeL4Data = [];
                        let enablementTypeISOData = [];
                        let enablementTypeDetailsData = [];
                        let enablementTypeRecommendationData = [];
                        let grandTotalObj = null;
    
                        /*
                         * ------------------------------------------------
                         * Read ALL data returned by the SAME API call
                         * ------------------------------------------------
                         */
    
                        response.data.Result.forEach((table) => {
    
                            if (Array.isArray(table['ENABLEMENT_TYPE'])) {
                                enablementTypeRows =
                                    enablementTypeRows.concat(
                                        table['ENABLEMENT_TYPE']
                                    );
                            }
    
                            if (Array.isArray(table['L4_INDUSTRY_GICS_ID'])) {
                                enablementTypeL4Data =
                                    enablementTypeL4Data.concat(
                                        table['L4_INDUSTRY_GICS_ID']
                                    );
                            }
    
                            if (Array.isArray(table['ISO_COUNTRY_CODE'])) {
                                enablementTypeISOData =
                                    enablementTypeISOData.concat(
                                        table['ISO_COUNTRY_CODE']
                                    );
                            }
    
                            if (Array.isArray(table['ONBOARDING_WORKSTREAM_DETAILS'])) {
                                enablementTypeDetailsData =
                                    enablementTypeDetailsData.concat(
                                        table['ONBOARDING_WORKSTREAM_DETAILS']
                                    );
                            }
    
                            if (Array.isArray(table['ENABLEMENT_WAVE'])) {

                                const recommendationRows =
                                    table['ENABLEMENT_WAVE'].filter(
                                        item =>
                                            item &&
                                            Object.prototype.hasOwnProperty.call(
                                                item,
                                                'SAP_ARIBA_BUY_ENABLE_MTHD_RECMD'
                                            )
                                    );
                        
                                if (recommendationRows.length > 0) {
                                    enablementTypeRecommendationData =
                                        enablementTypeRecommendationData.concat(
                                            recommendationRows
                                        );
                                }
                            }
    
                            if (table['GrandTotal'] !== undefined) {
                                grandTotalObj = table['GrandTotal'];
                            }
                        });
    
                        // console.log(
                        //     "Enablement Type API - All Data",
                        //     response.data.Result
                        // );
    
                        // console.log(
                        //     "Enablement Type Rows",
                        //     enablementTypeRows
                        // );
    
                        // console.log(
                        //     "Enablement Type L4 Data",
                        //     enablementTypeL4Data
                        // );
    
                        // console.log(
                        //     "Enablement Type ISO Data",
                        //     enablementTypeISOData
                        // );
    
                        // console.log(
                        //     "Enablement Type Details Data",
                        //     enablementTypeDetailsData
                        // );
    
                        // console.log(
                        //     "Enablement Type Recommendation Data",
                        //     enablementTypeRecommendationData
                        // );
    
                        /*
                         * ------------------------------------------------
                         * Store all four datasets.
                         *
                         * This is important because when the dropdown
                         * changes we can rebuild the hierarchy locally
                         * without making another API call.
                         * ------------------------------------------------
                         */
    
                        this.setState({
                            enablementTypeRows: enablementTypeRows,
                            enablementTypeL4Data: enablementTypeL4Data,
                            enablementTypeISOData: enablementTypeISOData,
                            enablementTypeDetailsData: enablementTypeDetailsData,
                            enablementTypeRecommendationData: enablementTypeRecommendationData,
                            enablementTypeGrandTotal: grandTotalObj
                        }, () => {
    
                            /*
                             * Build the hierarchy for the currently
                             * selected dropdown value.
                             *
                             * buildEnablementTypeView() should select
                             * the appropriate L4 dataset and call
                             * convertEnablementTypeResponse().
                             */
    
                            this.buildEnablementTypeView(
                                this.state.selectedTableView
                            );
    
                        });
    
                        this.props.enablementInsightSuccess(true);
    
                    } else {
    
                        this.setState({
                            enablementTypeJson: null,
                            enablementWaveTotal: null,
                            isLoading: false
                        });
    
                    }
    
                })
                .catch((error) => {
    
                    console.error(
                        "Enablement Type API Error:",
                        error
                    );
    
                    if (
                        error &&
                        error.stack &&
                        error.stack.includes('Network Error')
                    ) {
    
                        this.setState({
                            responseMsg:
                                'API service is down. Please contact administrator',
                            isError: 'Yes',
                            isLoading: false
                        });
    
                        this.props.enablementInsightFailure(
                            'API service is down. Please contact administrator.'
                        );
    
                    } else {
    
                        this.setState({
                            responseMsg: 'An error has occurred',
                            isError: 'Yes',
                            isLoading: false
                        });
    
                        this.props.enablementInsightFailure(
                            this.props.content.error
                        );
                    }
                });
    
            /*
             * VERY IMPORTANT:
             *
             * Do not continue to the normal
             * getEnablementStrategyDetails() API call.
             */
            return;
        }
    
    
        /*
         * ============================================================
         * NORMAL ENABLEMENT VIEWS
         * ============================================================
         *
         * Existing API and processing remains unchanged.
         * ============================================================
         */
    
        this.props.getEnablementStrategyDetails(inputParam)
            .then((response) => {
    
                if (
                    response !== undefined &&
                    response.status === 200 &&
                    response.data.Result !== undefined
                ) {
    
                    var enablementWaveData;
                    var enablementWaveTotal;
    
                    var l4IndustryData;
                    var l4IndustryDataTotal;
    
                    var onWorkStreamData;
                    var onWorkStreamDataTotal;
    
                    var isoCountryCodeData;
                    var isoCountryCodeDataTotal;
    
                    var enablementWaveANIDsData;
                    var headerLevelGrandTotal;
    
                    var ganttChartWorkStreamData;
    
    
                    // console.log('Old');
                    // console.log(response.data.Result);
    
    
                    var tables = response.data.Result.map(
                        function (table) {
    
                            if (
                                table['ENABLEMENT_WAVE'] !== undefined
                            ) {
    
                                enablementWaveData =
                                    table['ENABLEMENT_WAVE'];
    
                                enablementWaveTotal =
                                    table['GrandTotal'];
                            }
    
    
                            if (
                                table['L4_INDUSTRY_GICS_ID'] !== undefined
                            ) {
    
                                l4IndustryData =
                                    table['L4_INDUSTRY_GICS_ID'];
    
                                l4IndustryDataTotal =
                                    table['GrandTotal'];
                            }
    
    
                            if (
                                table['ISO_COUNTRY_CODE'] !== undefined
                            ) {
    
                                isoCountryCodeData =
                                    table['ISO_COUNTRY_CODE'];
    
                                isoCountryCodeDataTotal =
                                    table['GrandTotal'];
                            }
    
    
                            if (
                                table['ONBOARDING_WORKSTREAM_DETAILS'] !== undefined
                            ) {
    
                                onWorkStreamData =
                                    table['ONBOARDING_WORKSTREAM_DETAILS'];
    
                                onWorkStreamDataTotal =
                                    table['GrandTotal'];
                            }
    
    
                            if (
                                table['ENABLEMENT_WAVE_ANIDs'] !== undefined
                            ) {
    
                                enablementWaveANIDsData =
                                    table['ENABLEMENT_WAVE_ANIDs'];
    
                                headerLevelGrandTotal =
                                    table['GrandTotal'];
                            }
    
    
                            if (
                                table['GANTT_CHART_WORKSTREAM_NAME'] !== undefined
                            ) {
    
                                ganttChartWorkStreamData =
                                    table['GANTT_CHART_WORKSTREAM_NAME'];
                            }
    
                        }
                    );
    
    
                    /*
                     * ------------------------------------------------
                     * Convert normal-view data
                     * ------------------------------------------------
                     */
    
                    const l4IndustryDataTemp =
                        this.convertResponseToJson(
                            l4IndustryData,
                            enablementWaveANIDsData,
                            ganttChartWorkStreamData,
                            "FIELD_DESC"
                        );
    
    
                    const isoCountryDataTemp =
                        this.convertResponseToJson(
                            isoCountryCodeData,
                            enablementWaveANIDsData,
                            ganttChartWorkStreamData,
                            "ISO_COUNTRY_CODE"
                        );
    
    
                    const onWorkStreamDataTemp =
                        this.convertResponseToJson(
                            onWorkStreamData,
                            enablementWaveANIDsData,
                            ganttChartWorkStreamData,
                            "ONBOARDING_WORKSTREAM_DETAILS"
                        );
    
    
                    const enablementWaveDataTemp =
                        this.convertResponseToJson(
                            enablementWaveData,
                            enablementWaveANIDsData,
                            ganttChartWorkStreamData,
                            "SAP_ARIBA_BUY_ENABLE_MTHD_RECMD"
                        );
    
    
                    /*
                     * ------------------------------------------------
                     * Update normal-view state
                     * ------------------------------------------------
                     */
    
                    this.setState({
                        enablementWaveJson:
                            enablementWaveDataTemp,
    
                        enablementWaveTotal:
                            headerLevelGrandTotal,
    
                        isLoading:
                            false,
    
                        l4IndustryDataJson:
                            l4IndustryDataTemp,
    
                        isoCountryDataJson:
                            isoCountryDataTemp,
    
                        onWorkStreamDataJson:
                            onWorkStreamDataTemp
                    });
    
    
                    this.props.enablementInsightSuccess(true);
    
                }
    
            })
            .catch((error) => {
    
                if (
                    error &&
                    error.stack &&
                    error.stack.includes('Network Error')
                ) {
    
                    this.setState({
                        responseMsg:
                            'API service is down. Please contact administrator',
                        isError: 'Yes'
                    });
    
                    this.props.enablementInsightFailure(
                        'API service is down. Please contact administrator.'
                    );
    
                } else {
    
                    this.setState({
                        responseMsg:
                            'An error has occurred',
                        isError: 'Yes'
                    });
    
                    this.props.enablementInsightFailure(
                        this.props.content.error
                    );
                }
    
            });
    }

    convertResponseToJson(enablementData, aggregatedData, ganttChartWorkStreamData, thirdLevel) {
        let data = []
        let total = {}
        let waveToItem = {}
        let waveOrder = []
        let ganttChartTotal = {}
        let ganttChartToItem = {}
        //const enablementWaveData = this.state.enablementWaveData
        enablementData.forEach(item => {
            let datum = {
                ENABLEMENT_WAVE: item.ENABLEMENT_WAVE,
                GANTT_CHART_WORKSTREAM_NAME: item.GANTT_CHART_WORKSTREAM_NAME,
                [thirdLevel]: item[thirdLevel],//.SAP_ARIBA_BUY_ENABLE_MTHD_RECMD,
                CNT_VENDOR_NAME: isNaN(item.CNT_VENDOR_NAME) ? 0 : item.CNT_VENDOR_NAME,
                CNT_VENDOR_PER: isNaN(item.CNT_VENDOR_PER) ? 0 : Number.parseFloat(item.CNT_VENDOR_PER),
                CNT_UNIQ_VENDOR_AN_ID: isNaN(item.CNT_UNIQ_VENDOR_AN_ID) ? 0 : Number.parseFloat(item.CNT_UNIQ_VENDOR_AN_ID),
                SUM_AGGR_SPEND: isNaN(item.SUM_AGGR_SPEND) ? 0 : item.SUM_AGGR_SPEND,
                SUM_AGGR_SPEND_PER: isNaN(item.SUM_AGGR_SPEND_PER) ? 0 : Number.parseFloat(item.SUM_AGGR_SPEND_PER),

                SUM_SAP_ARIBA_DOC_PROXY: isNaN(item.SUM_SAP_ARIBA_DOC_PROXY) ? 0 : item.SUM_SAP_ARIBA_DOC_PROXY,
                SAP_ARIBA_DOC_PROXY_PER: isNaN(item.SAP_ARIBA_DOC_PROXY_PER) ? 0 : Number.parseFloat(item.SAP_ARIBA_DOC_PROXY_PER)
            }

            data.push(datum)

            let datumCopy = { ...datum }
            let datumCopy1 = { ...datum }

            if (item.ENABLEMENT_WAVE in total) {
                waveToItem[item.ENABLEMENT_WAVE].push(datumCopy1)

                let partialTotal = total[item.ENABLEMENT_WAVE]
                partialTotal.CNT_VENDOR_NAME = 0
                partialTotal.CNT_VENDOR_PER = 0
                partialTotal.CNT_UNIQ_VENDOR_AN_ID = 0
                partialTotal.SUM_AGGR_SPEND = 0
                partialTotal.SUM_AGGR_SPEND_PER = 0

                partialTotal.SUM_AGGR_PO_SPEND = 0
                partialTotal.SUM_AGGR_PO_SPEND_PER = 0

                partialTotal.SUM_SAP_ARIBA_DOC_PROXY = 0
                partialTotal.SAP_ARIBA_DOC_PROXY_PER = 0

            } else {

                total[item.ENABLEMENT_WAVE] = datumCopy
                waveToItem[item.ENABLEMENT_WAVE] = [datumCopy1]

                // preserve API order
                waveOrder.push(item.ENABLEMENT_WAVE)
            }

            if (item.GANTT_CHART_WORKSTREAM_NAME in ganttChartTotal) {
                ganttChartToItem[item.GANTT_CHART_WORKSTREAM_NAME].push(datumCopy1)

                let partialTotal = ganttChartTotal[item.GANTT_CHART_WORKSTREAM_NAME]
                partialTotal.CNT_VENDOR_NAME = 0
                partialTotal.CNT_VENDOR_PER = 0
                partialTotal.CNT_UNIQ_VENDOR_AN_ID = 0
                partialTotal.SUM_AGGR_SPEND = 0
                partialTotal.SUM_AGGR_SPEND_PER = 0

                partialTotal.SUM_AGGR_PO_SPEND = 0
                partialTotal.SUM_AGGR_PO_SPEND_PER = 0

                partialTotal.SUM_SAP_ARIBA_DOC_PROXY = 0
                partialTotal.SAP_ARIBA_DOC_PROXY_PER = 0

            } else {

                ganttChartTotal[item.GANTT_CHART_WORKSTREAM_NAME] = datumCopy
                ganttChartToItem[item.GANTT_CHART_WORKSTREAM_NAME] = [datumCopy1]
            }

        })

        let enablementWaveDetails = {
            rows: []
        }

        //  console.log("waveToItem.....", waveToItem)
        //  console.log("ganttChartToItem......", ganttChartToItem)

        waveOrder.forEach((key) => {

            const value = waveToItem[key]

            let recommendationChild = []


            for (const [recKey, recValue] of Object.entries(ganttChartToItem)) {

                let tempData = recValue.filter(item => item.ENABLEMENT_WAVE === key && item.GANTT_CHART_WORKSTREAM_NAME === recKey)

                tempData.forEach((item, index) => {
                    recommendationChild.push({
                        childContentId: index,
                        content: item[thirdLevel],//.SAP_ARIBA_BUY_ENABLE_MTHD_RECMD, 
                        parent: item.GANTT_CHART_WORKSTREAM_NAME,
                        enablementWave: item.ENABLEMENT_WAVE,
                        data: item,
                        expand: false
                    })
                })
            }

            let collapseChild = []
            let idx = 0
            value.forEach((item, index) => {
                if (!collapseChild.some(i => i.content === item.GANTT_CHART_WORKSTREAM_NAME)) {

                    collapseChild.push({
                        childContentId: index,
                        content: item.GANTT_CHART_WORKSTREAM_NAME,
                        enablementWave: key,
                        data: ganttChartWorkStreamData.find(
                            a =>
                                a &&
                                a.ENABLEMENT_WAVE === key &&
                                a.GANTT_CHART_WORKSTREAM_NAME === item.GANTT_CHART_WORKSTREAM_NAME
                        ) || {},
                        expand: false
                        , collapseChild: recommendationChild.filter(rec => rec.enablementWave === key && rec.parent === item.GANTT_CHART_WORKSTREAM_NAME)
                    })
                }
            })

            enablementWaveDetails.rows.push({
                "content": (key == "null" ? '' : key),
                "contentId": idx++,
                "data": aggregatedData.filter(item => item.ENABLEMENT_WAVE === (key == "null" ? null : key))[0],
                expand: false,
                collapseChild: collapseChild
            });
        });

        //console.log("jsonData", enablementWaveDetails)
        return enablementWaveDetails
    }

 convertEnablementTypeResponse(
    enablementTypeData,
    grandTotalData,
    l4IndustryData,
    displayField = "FIELD_DESC"
) {

    const waveMap = new Map();

    /*
     * ============================================================
     * LEVEL 4 DATA
     * ============================================================
     *
     * displayField:
     *
     * enablementTypeL4
     *      -> FIELD_DESC
     *
     * enablementTypeISO
     *      -> ISO_COUNTRY_CODE
     *
     * enablementTypeDetails
     *      -> ONBOARDING_WORKSTREAM_DETAILS
     *
     * enablementTypeRecommendation
     *      -> SAP_ARIBA_BUY_ENABLE_MTHD_RECMD
     *
     * ============================================================
     */

    const l4Map = new Map();

    if (Array.isArray(l4IndustryData)) {

        l4IndustryData.forEach(item => {

            const wave = item.ENABLEMENT_WAVE;
            const type = item.ENABLEMENT_TYPE;
            const workstream = item.GANTT_CHART_WORKSTREAM_NAME;

            /*
             * Dynamically get the L4 value.
             */
            const l4Value = item[displayField];

            
            /*
             * Match L4 data with:
             *
             * Wave
             * +
             * Enablement Type
             * +
             * Workstream
             */
            const key =
                `${wave}|||${type}|||${workstream}`;

            if (!l4Map.has(key)) {
                l4Map.set(key, new Map());
            }

            const l4ByValue = l4Map.get(key);

            /*
             * Multiple records can have the same L4 value.
             * Aggregate them into one L4 row.
             */
            if (!l4ByValue.has(l4Value)) {

                l4ByValue.set(l4Value, {

                    /*
                     * Preserve all original API fields.
                     * This is useful for popup/details.
                     */
                    ...item,

                    ENABLEMENT_WAVE: wave,

                    ENABLEMENT_TYPE: type,

                    GANTT_CHART_WORKSTREAM_NAME:
                        workstream,

                    /*
                     * Keep the selected display value
                     * in the dynamically selected field.
                     */
                    [displayField]: l4Value,

                    CNT_VENDOR_NAME:
                        isNaN(item.CNT_VENDOR_NAME)
                            ? 0
                            : Number.parseFloat(
                                item.CNT_VENDOR_NAME
                            ),

                    CNT_VENDOR_PER:
                        isNaN(item.CNT_VENDOR_PER)
                            ? 0
                            : Number.parseFloat(
                                item.CNT_VENDOR_PER
                            ),

                    CNT_UNIQ_VENDOR_AN_ID:
                        isNaN(item.CNT_UNIQ_VENDOR_AN_ID)
                            ? 0
                            : Number.parseFloat(
                                item.CNT_UNIQ_VENDOR_AN_ID
                            ),

                    SUM_AGGR_SPEND:
                        isNaN(item.SUM_AGGR_SPEND)
                            ? 0
                            : Number.parseFloat(
                                item.SUM_AGGR_SPEND
                            ),

                    SUM_AGGR_SPEND_PER:
                        isNaN(item.SUM_AGGR_SPEND_PER)
                            ? 0
                            : Number.parseFloat(
                                item.SUM_AGGR_SPEND_PER
                            ),

                    SUM_SAP_ARIBA_DOC_PROXY:
                        isNaN(item.SUM_SAP_ARIBA_DOC_PROXY)
                            ? 0
                            : Number.parseFloat(
                                item.SUM_SAP_ARIBA_DOC_PROXY
                            ),

                    SAP_ARIBA_DOC_PROXY_PER:
                        isNaN(item.SAP_ARIBA_DOC_PROXY_PER)
                            ? 0
                            : Number.parseFloat(
                                item.SAP_ARIBA_DOC_PROXY_PER
                            )
                });

            } else {

                /*
                 * Same L4 value can occur multiple times.
                 * Add numeric values together.
                 */

                const existing =
                    l4ByValue.get(l4Value);

                [
                    'CNT_VENDOR_NAME',
                    'CNT_VENDOR_PER',
                    'CNT_UNIQ_VENDOR_AN_ID',
                    'SUM_AGGR_SPEND',
                    'SUM_AGGR_SPEND_PER',
                    'SUM_SAP_ARIBA_DOC_PROXY',
                    'SAP_ARIBA_DOC_PROXY_PER'
                ].forEach(keyName => {

                    const value =
                        Number.parseFloat(
                            item[keyName]
                        );

                    if (!Number.isNaN(value)) {

                        existing[keyName] += value;

                    }

                });

            }

        });

    }


    /*
     * ============================================================
     * LEVEL 1 / LEVEL 2 / LEVEL 3 DATA
     * ============================================================
     *
     * Level 1:
     *      ENABLEMENT_WAVE
     *
     * Level 2:
     *      ENABLEMENT_TYPE
     *
     * Level 3:
     *      GANTT_CHART_WORKSTREAM_NAME
     *
     * Level 4:
     *      Selected displayField
     *
     * ============================================================
     */

    if (!Array.isArray(enablementTypeData)) {

        return {
            rows: []
        };

    }


    enablementTypeData.forEach(item => {

        const wave =
            item.ENABLEMENT_WAVE;

        const type =
            item.ENABLEMENT_TYPE;

        const workstream =
            item.GANTT_CHART_WORKSTREAM_NAME;


        /*
         * ------------------------------------------------------------
         * LEVEL 1 - ENABLEMENT WAVE
         * ------------------------------------------------------------
         */

        if (!waveMap.has(wave)) {

            waveMap.set(wave, {

                waveTotals: {

                    ENABLEMENT_WAVE:
                        wave,

                    CNT_VENDOR_NAME: 0,

                    CNT_VENDOR_PER: 0,

                    CNT_UNIQ_VENDOR_AN_ID: 0,

                    SUM_AGGR_SPEND: 0,

                    SUM_AGGR_SPEND_PER: 0,

                    SUM_SAP_ARIBA_DOC_PROXY: 0,

                    SAP_ARIBA_DOC_PROXY_PER: 0
                },

                typesMap:
                    new Map()

            });

        }


        const waveEntry =
            waveMap.get(wave);

        const typesMap =
            waveEntry.typesMap;


        /*
         * ------------------------------------------------------------
         * LEVEL 2 - ENABLEMENT TYPE
         * ------------------------------------------------------------
         */

        if (!typesMap.has(type)) {

            typesMap.set(type, {

                typeTotals: {

                    ENABLEMENT_WAVE:
                        wave,

                    ENABLEMENT_TYPE:
                        type,

                    CNT_VENDOR_NAME: 0,

                    CNT_VENDOR_PER: 0,

                    CNT_UNIQ_VENDOR_AN_ID: 0,

                    SUM_AGGR_SPEND: 0,

                    SUM_AGGR_SPEND_PER: 0,

                    SUM_SAP_ARIBA_DOC_PROXY: 0,

                    SAP_ARIBA_DOC_PROXY_PER: 0

                },

                workstreamsMap:
                    new Map()

            });

        }


        const typeEntry =
            typesMap.get(type);

        const workstreamsMap =
            typeEntry.workstreamsMap;


        /*
         * ------------------------------------------------------------
         * LEVEL 3 - WORKSTREAM
         * ------------------------------------------------------------
         */

        const workstreamMetrics = {

            ENABLEMENT_WAVE:
                wave,

            ENABLEMENT_TYPE:
                type,

            GANTT_CHART_WORKSTREAM_NAME:
                workstream,

            CNT_VENDOR_NAME:
                isNaN(item.CNT_VENDOR_NAME)
                    ? 0
                    : Number.parseFloat(
                        item.CNT_VENDOR_NAME
                    ),

            CNT_VENDOR_PER:
                isNaN(item.CNT_VENDOR_PER)
                    ? 0
                    : Number.parseFloat(
                        item.CNT_VENDOR_PER
                    ),

            CNT_UNIQ_VENDOR_AN_ID:
                isNaN(item.CNT_UNIQ_VENDOR_AN_ID)
                    ? 0
                    : Number.parseFloat(
                        item.CNT_UNIQ_VENDOR_AN_ID
                    ),

            SUM_AGGR_SPEND:
                isNaN(item.SUM_AGGR_SPEND)
                    ? 0
                    : Number.parseFloat(
                        item.SUM_AGGR_SPEND
                    ),

            SUM_AGGR_SPEND_PER:
                isNaN(item.SUM_AGGR_SPEND_PER)
                    ? 0
                    : Number.parseFloat(
                        item.SUM_AGGR_SPEND_PER
                    ),

            SUM_SAP_ARIBA_DOC_PROXY:
                isNaN(item.SUM_SAP_ARIBA_DOC_PROXY)
                    ? 0
                    : Number.parseFloat(
                        item.SUM_SAP_ARIBA_DOC_PROXY
                    ),

            SAP_ARIBA_DOC_PROXY_PER:
                isNaN(item.SAP_ARIBA_DOC_PROXY_PER)
                    ? 0
                    : Number.parseFloat(
                        item.SAP_ARIBA_DOC_PROXY_PER
                    )
        };


        /*
         * Aggregate Workstream
         */

        if (!workstreamsMap.has(workstream)) {

            workstreamsMap.set(
                workstream,
                workstreamMetrics
            );

        } else {

            const existing =
                workstreamsMap.get(workstream);

            [
                'CNT_VENDOR_NAME',
                'CNT_VENDOR_PER',
                'CNT_UNIQ_VENDOR_AN_ID',
                'SUM_AGGR_SPEND',
                'SUM_AGGR_SPEND_PER',
                'SUM_SAP_ARIBA_DOC_PROXY',
                'SAP_ARIBA_DOC_PROXY_PER'
            ].forEach(key => {

                existing[key] +=
                    workstreamMetrics[key];

            });

        }


        /*
         * ------------------------------------------------------------
         * Aggregate to Enablement Type
         * ------------------------------------------------------------
         */

        const typeTotals =
            typeEntry.typeTotals;

        [
            'CNT_VENDOR_NAME',
            'CNT_VENDOR_PER',
            'CNT_UNIQ_VENDOR_AN_ID',
            'SUM_AGGR_SPEND',
            'SUM_AGGR_SPEND_PER',
            'SUM_SAP_ARIBA_DOC_PROXY',
            'SAP_ARIBA_DOC_PROXY_PER'
        ].forEach(key => {

            typeTotals[key] +=
                workstreamMetrics[key];

        });


        /*
         * ------------------------------------------------------------
         * Aggregate to Enablement Wave
         * ------------------------------------------------------------
         */

        const waveTotals =
            waveEntry.waveTotals;

        [
            'CNT_VENDOR_NAME',
            'CNT_VENDOR_PER',
            'CNT_UNIQ_VENDOR_AN_ID',
            'SUM_AGGR_SPEND',
            'SUM_AGGR_SPEND_PER',
            'SUM_SAP_ARIBA_DOC_PROXY',
            'SAP_ARIBA_DOC_PROXY_PER'
        ].forEach(key => {

            waveTotals[key] +=
                workstreamMetrics[key];

        });

    });


    /*
     * ============================================================
     * BUILD FINAL 4 LEVEL HIERARCHY
     * ============================================================
     */

    const rows = [];

    const waveOrder = [
        ...waveMap.keys()
    ];


    /*
     * ============================================================
     * LEVEL 1 - WAVE
     * ============================================================
     */

    waveOrder.forEach((wave, waveIdx) => {

        const waveEntry =
            waveMap.get(wave);

        const waveTotals =
            waveEntry.waveTotals;

        const typesMap =
            waveEntry.typesMap;


        const typeOrder = [
            ...typesMap.keys()
        ];


        /*
         * ========================================================
         * LEVEL 2 - ENABLEMENT TYPE
         * ========================================================
         */

        const typeChildren =
            typeOrder.map((type, typeIdx) => {

                const typeEntry =
                    typesMap.get(type);

                const typeTotals =
                    typeEntry.typeTotals;

                const workstreamsMap =
                    typeEntry.workstreamsMap;


                const workstreamOrder = [
                    ...workstreamsMap.keys()
                ];


                /*
                 * =================================================
                 * LEVEL 3 - WORKSTREAM
                 * =================================================
                 */

                const workstreamChildren =
                    workstreamOrder.map(
                        (ws, wsIdx) => {

                            const wsData =
                                workstreamsMap.get(ws);


                            /*
                             * -------------------------------------------------
                             * Find Level 4 records
                             * -------------------------------------------------
                             */

                            const l4Key =
                                `${wave}|||${type}|||${ws}`;


                            const l4Rows =
                                l4Map.has(l4Key)
                                    ? [
                                        ...l4Map
                                            .get(l4Key)
                                            .values()
                                    ]
                                    : [];


                            /*
                             * =================================================
                             * LEVEL 4
                             * =================================================
                             */

                            const l4Children =
                                l4Rows.map(
                                    (l4Item, l4Idx) => {

                                        return {

                                            childContentId:
                                                l4Idx,

                                            /*
                                             * IMPORTANT:
                                             *
                                             * Display the selected field.
                                             */
                                            content:
                                                l4Item[
                                                    displayField
                                                ],

                                            /*
                                             * Complete L4 data
                                             */
                                            data:
                                                l4Item,

                                            /*
                                             * Parent = Workstream
                                             */
                                            parent:
                                                ws,

                                            enablementWave:
                                                wave,

                                            enablementType:
                                                type,

                                            secondLevelValue:
                                                type,

                                            thirdLevelValue:
                                                ws,
                                            fourthLevelValue: l4Item[displayField],

                                            expand:
                                                false
                                        };

                                    }
                                );


                            /*
                             * =================================================
                             * LEVEL 3 WORKSTREAM OBJECT
                             * =================================================
                             */

                            return {

                                childContentId:
                                    wsIdx,

                                content:
                                    ws,

                                data:
                                    wsData,

                                parent:
                                    type,

                                enablementWave:
                                    wave,

                                secondLevelValue:
                                    type,

                                level2:
                                    type,

                                secondLevelContent:
                                    type,

                                expand:
                                    false,

                                /*
                                 * LEVEL 4 CHILDREN
                                 */
                                collapseChild:
                                    l4Children

                            };

                        }
                    );


                /*
                 * ========================================================
                 * LEVEL 2 ENABLEMENT TYPE OBJECT
                 * ========================================================
                 */

                return {

                    childContentId:
                        typeIdx,

                    content:
                        type,

                    data:
                        typeTotals,

                    enablementWave:
                        wave,

                    secondLevelValue:
                        type,

                    expand:
                        false,

                    /*
                     * LEVEL 3 CHILDREN
                     */
                    collapseChild:
                        workstreamChildren

                };

            });


        /*
         * ============================================================
         * LEVEL 1 WAVE OBJECT
         * ============================================================
         */

        rows.push({

            content:
                wave,

            contentId:
                waveIdx,

            data:
                waveTotals,

            expand:
                false,

            /*
             * LEVEL 2 CHILDREN
             */
            collapseChild:
                typeChildren

        });

    });


    /*
     * ============================================================
     * RETURN DATA FOR ExpandableTable
     * ============================================================
     */

    return {
        rows
    };
}

    componentWillReceiveProps(nextProps, nextState) {
        if (this.state.Test !== nextProps.filterData && 'dedupStats' in nextProps.filterData) {
            var inputParameter = this.state.inputParam
            inputParameter.dedupStats = nextProps.filterData.dedupStats
            inputParameter.enabledCustomer = nextProps.filterData.enabledCustomer
            inputParameter.transactingCustomer = nextProps.filterData.transactingCustomer
            inputParameter.buyerRegion = nextProps.filterData.buyerRegion
            inputParameter.businessUnit = nextProps.filterData.businessUnit
            inputParameter.erpSystem = nextProps.filterData.erpSystem
            inputParameter.l4IndustryName = nextProps.filterData.l4IndustryName
            inputParameter.erpCode = nextProps.filterData.erpCode
            inputParameter.erpDesc = nextProps.filterData.erpDesc
            inputParameter.sicCode = nextProps.filterData.sicCode
            inputParameter.sicDesc = nextProps.filterData.sicDesc
            inputParameter.goods = nextProps.filterData.goods
            inputParameter.invoiceCountry = nextProps.filterData.invoiceCountry
            inputParameter.legalInvoice = nextProps.filterData.legalInvoice
            inputParameter.aribaNwEligible = nextProps.filterData.aribaNwEligible
            inputParameter.metricsType = nextProps.filterData.metricsType
            inputParameter.directSpend = nextProps.filterData.directSpend

            setTimeout(() => {
                this.GetEnablementDetails(inputParameter);
            }, 1000);

            this.setState({ Test: nextProps.filterData, inputParam: Object.keys(nextProps.filterData).length !== 0 ? nextProps.filterData : this.state.inputParam })
            //console.log("if enablemtn details filetr props-")
        }
        else {
            //  console.log("else enablemtn details filetr props-")
        }

    }

    onExpandClick(e) {
        switch (e.target.id) {
            case "l4Industry":
                this.setState({ isL4Expand: !this.state.isL4Expand })
                break;

            case "country":
                this.setState({ isCountryExpand: !this.state.isCountryExpand })
                break;

            case "onboardWrk":
                this.setState({ isOnboardWrkExpand: !this.state.isOnboardWrkExpand })
                break;

            case "recmd":
                this.setState({ isRECMDExpand: !this.state.isRECMDExpand })
                break;

        }
        this.GetEnablementDetails(this.state.inputParam)
    }

    handleFocusChange(data) {
        var activeRequestData = this.state.activeRequest
        activeRequestData.ENABLEMENT_STRATEGY_FOCUS = data.value
        this.setState({ selectedTableView: data.value, isLoading: true }, () => {

            var requestParam = {
                VS_ID: this.state.inputParam.VS_ID,
                DMC_ID: this.state.inputParam.DMC_ID,
                ENABLEMENT_STRATEGY_FOCUS: data.value
            }

            this.updateEnablementStrategyFocus(requestParam)
            this.props.currentActiveRequest(activeRequestData)
            this.GetEnablementDetails(this.state.inputParam)
        })

        // var requestParam={
        //     VS_ID: this.state.inputParam.VS_ID,
        //     DMC_ID: this.state.inputParam.DMC_ID,
        //     ENABLEMENT_STRATEGY_FOCUS: data.value
        // }

        // this.updateEnablementStrategyFocus(requestParam)
        // this.props.currentActiveRequest(activeRequestData)
        // this.GetEnablementDetails(this.state.inputParam)  
    }

    updateEnablementStrategyFocus(requestParam) {

        this.props.updateEnablementStrategyCurrentFocus(requestParam.VS_ID, requestParam.DMC_ID, requestParam.ENABLEMENT_STRATEGY_FOCUS)
            .then((response) => {
                if (response !== undefined && response.status === 200 && response.data.Result !== undefined) {

                }
            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.setState({ responseMsg: 'API service is down. Please contact administrator', isError: 'Yes' })
                    this.props.enablementInsightFailure('API service is down. Please contact administrator.')
                }
                else {
                    this.setState({ responseMsg: 'An error has occurred', isError: 'Yes' })
                    this.props.enablementInsightFailure(this.props.content.error)
                }
            })
    }

    render() {
        return (
            <div className="grid-x" style={{ width: '100%' }}>

                <div className="medium-12">
                    {(this.state.isLoading) ?
                        <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} src={path + `images/ajax-loader.gif`} alt="" />
                        : null
                    }
                    {(this.state.isError === 'Yes') ?
                        <div style={{ color: 'red', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                        : <div style={{ color: 'green', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                    }
                </div>

                <div className="grid-x medium-12 pr15">
                    <div className="medium-6">
                        <div className="dropDownHeader">{"Focus"} </div>
                        <div className="control-wrapper" style={{ width: '80%' }}>
                            <SelectE
                                className="border-with-DD"
                                autocomplete='true'
                                //placeholder={this.props.content.notConfirmed}
                                value={
                                    (
                                        this.props.spendDetails.currentActiveRequest.DIRECT_CONNECT_WAVE == 'Onboarding_Workstream'
                                            ? this.state.tableNameOptionForEnablemenType
                                            : this.state.tableNameOption
                                    ).filter(
                                        option => option.value === this.state.selectedTableView
                                    )
                                }
                                noOptionsMessage={() => null}
                                onChange={value => this.handleFocusChange(value)}
                                options={this.props.spendDetails.currentActiveRequest.DIRECT_CONNECT_WAVE == 'Onboarding_Workstream' ? this.state.tableNameOptionForEnablemenType : this.state.tableNameOption}
                                isSearchable={false}
                                styles={dropdownColourStyles}
                                isDisabled={this.state.isLoading}
                            />
                        </div>
                    </div>
                </div>

                <div className="grid-x medium-12 pt10"></div>
                <br></br>

                {[
    "enablementTypeL4",
    "enablementTypeISO",
    "enablementTypeDetails",
    "enablementTypeRecommendation"
].includes(this.state.selectedTableView) ? (
                    <div className="medium-12">
                        <div className="grid-x medium-12">
                            {this.state.enablementTypeJson !== undefined && this.state.enablementTypeJson !== null ? (
                                <ExpandableTable
                                    data={this.state.enablementTypeJson}
                                    grandTotal={this.state.enablementWaveTotal}
                                    content={this.props.content.enablementWaveDetails}
                                    // ✅ Use the content constant, not a hardcoded string
                                    tableName={this.props.content.enablementWaveDetails.enablementStrategyByEnablementType}
                                    tableSequence={"26"}
                                    showEnablementSupplierDetailsModal={this.showEnablementSupplierDetailsModal}
                                    metricsType={this.state.inputParam.metricsType}
                                    reloadEnablementWave={this.reloadEnablementWave}
                                    tabName={'Enablement Strategy'}
                                    //selectedTableView={this.state.selectedTableView}
                                />
                            ) : (
                                <div className="pt10">{this.props.content.noDataFound}</div>
                            )}
                        </div>
                    </div>
                ) : null}

                {this.state.selectedTableView === "l4Industry" ?

                    // <div className="grid-x medium-12 pb10 pt10 tab-title ">
                    // <div className="grid-x medium-12 heading-with-below-border">
                    //     <div className="medium-11" style={{ fontWeight: '500'}}>{"Enablement Strategy by Onboarding Workstream with L4 Industry Name"}</div>
                    //     <div className="medium-1" id="l4Industry" style={{ textAlign:'right', cursor:'pointer', fontSize: '1.6rem' }}
                    //      onClick={(e)=> this.onExpandClick(e)} >{this.state.isL4Expand ? "-": "+"}</div>                    
                    // </div>
                    // </div>    


                    <div className="medium-12">
                        <div className="grid-x medium-12">
                            {this.state.l4IndustryDataJson !== undefined && this.state.l4IndustryDataJson !== null ?
                                <ExpandableTable
                                    data={this.state.l4IndustryDataJson}
                                    grandTotal={this.state.enablementWaveTotal}
                                    content={this.props.content.enablementWaveDetails}
                                    //content ={this.state.enablementWaveJson}
                                    tableName={this.props.content.enablementWaveDetails.enablementStrategyByL4Industry}
                                    tableSequence={"26"}
                                    showEnablementSupplierDetailsModal={this.showEnablementSupplierDetailsModal}
                                    metricsType={this.state.inputParam.metricsType}
                                    reloadEnablementWave={this.reloadEnablementWave}
                                    tabName={'Enablement Strategy'}
                                    //selectedTableView={this.state.selectedTableView}
                                />
                                : <div className="pt10">{this.props.content.noDataFound}</div>}
                        </div>
                    </div>

                    : null}

                {/* <div className="grid-x medium-12 pb10 tab-title ">
                <div className="grid-x medium-12 heading-with-below-border">
                    <div className="medium-11" style={{ fontWeight: '500'}}>{"Enablement Strategy by ISO Country Code"}</div>
                    <div className="medium-1" id="country" style={{ textAlign:'right', cursor:'pointer', fontSize: '1.6rem' }}
                     onClick={(e)=> this.onExpandClick(e)} >{this.state.isCountryExpand ? "-": "+"}</div>                    
                </div>
                </div>    */}

                {this.state.selectedTableView === "isoCountry" ?
                    <div className="medium-12">
                        <div className="grid-x medium-12">
                            {this.state.isoCountryDataJson !== undefined && this.state.isoCountryDataJson !== null ?
                                <ExpandableTable
                                    data={this.state.isoCountryDataJson}
                                    grandTotal={this.state.enablementWaveTotal}
                                    content={this.props.content.enablementWaveDetails}
                                    //content ={this.state.enablementWaveJson}
                                    tableName={this.props.content.enablementWaveDetails.enablementStrategyByISOCountry}
                                    tableSequence={"26"}
                                    showEnablementSupplierDetailsModal={this.showEnablementSupplierDetailsModal}
                                    metricsType={this.state.inputParam.metricsType}
                                    reloadEnablementWave={this.reloadEnablementWave}
                                    tabName={'Enablement Strategy'}
                                    //selectedTableView={this.state.selectedTableView}
                                />
                                : <div className="pt10">{this.props.content.noDataFound}</div>}
                        </div>
                    </div>
                    : null}

                {/* <div className="grid-x medium-12 pb10 tab-title ">
                <div className="grid-x medium-12 heading-with-below-border">
                    <div className="medium-11" style={{ fontWeight: '500'}}>{"Enablement Strategy by Onboarding Workstream with Details"}</div>
                    <div className="medium-1" id="onboardWrk" style={{ textAlign:'right', cursor:'pointer', fontSize: '1.6rem' }}
                     onClick={(e)=> this.onExpandClick(e)} >{this.state.isOnboardWrkExpand ? "-": "+"}</div>                    
                </div>
                </div>    */}

                {this.state.selectedTableView === "workstreamDetails" ?
                    <div className="medium-12">
                        <div className="grid-x medium-12">
                            {this.state.onWorkStreamDataJson !== undefined && this.state.onWorkStreamDataJson !== null ?
                                <ExpandableTable
                                    data={this.state.onWorkStreamDataJson}
                                    grandTotal={this.state.enablementWaveTotal}
                                    content={this.props.content.enablementWaveDetails}
                                    //content ={this.state.enablementWaveJson}
                                    tableName={this.props.content.enablementWaveDetails.enablementStrategyByOnboardingWorkstream}
                                    tableSequence={"26"}
                                    showEnablementSupplierDetailsModal={this.showEnablementSupplierDetailsModal}
                                    metricsType={this.state.inputParam.metricsType}
                                    reloadEnablementWave={this.reloadEnablementWave}
                                    tabName={'Enablement Strategy'}
                                    //selectedTableView={this.state.selectedTableView}
                                />
                                : <div className="pt10">{this.props.content.noDataFound}</div>}
                        </div>
                    </div>
                    : null}

                {/* <div className="grid-x medium-12 pb10 tab-title ">
                <div className="grid-x medium-12 heading-with-below-border">
                    <div className="medium-11" style={{ fontWeight: '500'}}>{"Enablement Strategy by Onboarding Workstream with Enablement Recommendation"}</div>
                    <div className="medium-1" id="recmd" style={{ textAlign:'right', cursor:'pointer', fontSize: '1.6rem' }}
                     onClick={(e)=> this.onExpandClick(e)} >{this.state.isRECMDExpand ? "-": "+"}</div>                    
                </div>
                </div>    */}

                {this.state.selectedTableView === "workstreamRecommendation" ?
                    <div className="medium-12">
                        <div className="grid-x medium-12">
                            {this.state.enablementWaveJson !== undefined && this.state.enablementWaveJson !== null ?
                                <ExpandableTable
                                    data={this.state.enablementWaveJson}
                                    grandTotal={this.state.enablementWaveTotal}
                                    content={this.props.content.enablementWaveDetails}
                                    //content ={this.state.enablementWaveJson}
                                    tableName={this.props.content.enablementWaveDetails.enablementStrategyByRecommendation}
                                    tableSequence={"26"}
                                    showEnablementSupplierDetailsModal={this.showEnablementSupplierDetailsModal}
                                    metricsType={this.state.inputParam.metricsType}
                                    reloadEnablementWave={this.reloadEnablementWave}
                                    tabName={'Enablement Strategy'}
                                    //selectedTableView={this.state.selectedTableView}
                                />
                                : <div className="pt10">{this.props.content.noDataFound}</div>}
                        </div>
                    </div>
                    :
                    null}

                <div>
                    {this.refs.enablementSupplier ? this.state.openPopup ?
                        this.refs.enablementSupplier.show() :
                        this.refs.enablementSupplier.hide() : ''}
                    <Modal
                        ref={'enablementSupplier'}
                        modalStyle={changeModalBorderStyle}
                        contentStyle={drilldownModalBorderContentStyle}
                        rectStyle={changeModalBorderRectStyle}
                        keyboard={false}
                        backdrop={false}
                    >
                        <div className="grid-x tabs_container supplier-tabs">
                            <div className="medium-12">
                                {
                                    <EnablementSupplierDetailsPopup onSave={this.onSave} input={this.state.inputParam} outsidePopupClick={this.outsidePopupClick} ></EnablementSupplierDetailsPopup>
                                }
                            </div>
                        </div>
                        <button onClick={() => { this.setVisibility(false); this.setState({ selectedIndustryName: {} }) }} className='close' />
                    </Modal>
                </div>
                {/* <div><EnablementSupplierPopup open={this.state.openPopup} visibility={this.setVisibility} outsidePopupClick={this.outsidePopupClick} ></EnablementSupplierPopup></div> */}
            </div>
        )
    }

}


const mapStateToProps = state => {
    return {
        content: state.content.enablementInsight,
        //content: state.content.subLeverCalculations,
        ui: state.content.ui,
        currency: decodeURIComponent(state.valueStory.Currency),
        userData: state.valueStory,
        spendAsPercentageOfRevenue: state.spendAsPercentageOfRevenue,
        benchMarkCalculations: state.benchMarksData,
        allContent: state.content,
        language: state.language,
        spendDetails: state.spendDetails,
        user: state.default
    }
}

const mapDispatchToProps = dispatch => {
    return {
        enablementInsightSuccess: message => dispatch(enablementInsightSuccess(message)),
        enablementInsightFailure: error => dispatch(enablementInsightFailure(error)),
        enablementInsightLoading: bool => dispatch(enablementInsightLoading(bool)),
        resetError: error => dispatch(resetError(error)),
        getEnablementDetails: (data) => dispatch(getEnablementDetails(data)),
        getEnablementStrategyDetails: (data) => dispatch(getEnablementStrategyDetails(data)),
        getEnablementStrategyDetailsEnablementType: (data) => dispatch(getEnablementStrategyDetailsEnablementType(data)),
        getEnablementFiltersDetails: (data) => dispatch(getEnablementFiltersDetails(data)),
        currentActiveRequest: (requestDetails) => dispatch(currentActiveRequest(requestDetails)),
        updateEnablementStrategyCurrentFocus: (VS_ID, DMC_ID, ENABLEMENT_STRATEGY_FOCUS) => dispatch(updateEnablementStrategyCurrentFocus(VS_ID, DMC_ID, ENABLEMENT_STRATEGY_FOCUS))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnablementDetails)

